import Image from 'next/legacy/image';

export default function FramerPaste() {
  return (
    <li>
      <h3 id="paste-framer">Paste it in your Framer site</h3>
      <p>
        Add a new <code>Embed</code> element on the webpage, in your Framer project, and paste this
        code in the element.
      </p>
      <Image src="/guides/framer-paste.webp" width={800} height={486} alt="framer editor" />
      <p>
        <a href="https://www.framer.com/learn/how-to-add-an-iframe-or-embed-script/">Learn More</a>
      </p>
    </li>
  );
}
